import React, { useContext, useEffect } from 'react'
import { TranslateContext } from '../../translator'
import {
  getProductListTranslations,
  getPromotionsTextsTranslations
} from '../../../fragments/listerFragment/selectors/translations'
import { propConverter } from 'chemistry'
import { Card } from '../Card/Card'
import { algoliaCallWhenReady, getAlgoliaIndex, getProductPosition } from '../../utils'
import { MAXIMUM_VIEW_SIZE } from 'common/constants'

const ProductsGrid = ({
  sizes,
  format,
  lang,
  categoryCode,
  collection,
  searchResultType,
  onProductCardClick,
  cardTitle,
  target,
  cardsInRow = 4,
  withArrow,
  // needed for the frids with frontend-lib classes
  addClassName = true,
  showSoldByProductCards,
  showAvailabilityStatusMultiple,
  meta,
  page
}) => {
  const t = useContext(TranslateContext)

  // Track view events in algolia
  useEffect(() => {
    if (collection.length) {
      algoliaCallWhenReady('viewedObjectIDs', {
        eventName: 'Item Viewed',
        index: getAlgoliaIndex(),
        objectIDs: collection.map(({ id }) => id),
        type: '2'
      })
    }
  }, [collection])

  return (
    <>
      {Boolean(cardTitle) && cardTitle}
      {collection.map((props, index) => {
        const productListTranslations = getProductListTranslations(t)
        if (props.unitName) {
          const per = lang === 'fr' ? 'par' : 'per'
          const unitTranslated = t(`pim.units.${props.unitName}`)
          productListTranslations.units = `${per} ${unitTranslated}`
        }

        const cardProps = {
          ...props,
          meta,
          format,
          lang,
          isDetail: false,
          t: productListTranslations,
          texts: getPromotionsTextsTranslations(t),
          showPraxisPlusBanner: false,
          translate: t,
          showSoldByProductCards,
          showAvailabilityStatusMultiple
        }

        const fullPriceProps = propConverter(cardProps)
        return (
          <div
            key={`product-${props.ean}`}
            onClick={() => onProductCardClick(categoryCode, cardProps, searchResultType)}
            {...(addClassName ? { className: `mxd-width-1-${cardsInRow}` } : {})}
          >
            <Card
              {...cardProps}
              fullPriceProps={fullPriceProps}
              categoryCode={categoryCode}
              sizes={sizes}
              target={target}
              withArrow={withArrow}
              position={getProductPosition(index + 1, page, MAXIMUM_VIEW_SIZE)}
            />
          </div>
        )
      })}
    </>
  )
}

export default ProductsGrid
